import { graphqlClient } from '@/lib/graphql-client';
import { buildGetSkillSubCategoriesQuery } from '../graphql/queries';
import {
  DELETE_SKILL_SUB_CATEGORY_MUTATION,
  INSERT_SKILL_SUB_CATEGORY_MUTATION,
  UPDATE_SKILL_SUB_CATEGORY_MUTATION,
} from '../graphql/mutations';
import {
  GetSkillSubCategoriesParams,
  SkillSubCategoriesPagingResult,
  SkillSubCategoryInsertInput,
  SkillSubCategoryUpdateInput,
} from '../types/skill-sub-category.types';

export const getSkillSubCategories = async (
  params: GetSkillSubCategoriesParams
): Promise<{ SkillSubCategorys: SkillSubCategoriesPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetSkillSubCategoriesQuery(filter, pageNo, pageSize, order),
  }) as Promise<{ SkillSubCategorys: SkillSubCategoriesPagingResult }>;
};

export const createSkillSubCategory = async (input: SkillSubCategoryInsertInput) => {
  return graphqlClient.mutate({ query: INSERT_SKILL_SUB_CATEGORY_MUTATION, variables: { input } });
};

export const updateSkillSubCategory = async (params: {
  itemId: string;
  input: SkillSubCategoryUpdateInput;
}) => {
  const filter = JSON.stringify({ _id: params.itemId });
  return graphqlClient.mutate({
    query: UPDATE_SKILL_SUB_CATEGORY_MUTATION,
    variables: { filter, input: params.input },
  });
};

export const deleteSkillSubCategory = async (itemId: string) => {
  const filter = JSON.stringify({ _id: itemId });
  return graphqlClient.mutate({
    query: DELETE_SKILL_SUB_CATEGORY_MUTATION,
    variables: { filter, input: { isHardDelete: false } },
  });
};
